import { makeStyles } from '@map/theme';
import { ReactElement, cloneElement, isValidElement } from 'react';

const useStyles = makeStyles(
  (
    { palette },
    {
      colorPalette,
      transparentBackground,
    }: Pick<SVGProps, 'colorPalette' | 'transparentBackground'>,
  ) => {
    const isWhite = colorPalette === 'white';
    const isNeutrals = colorPalette === 'neutrals';
    const backgroundFill = isWhite ? palette.primary[300] : palette[colorPalette!][200];
    return {
      root: {
        '& .fg': {
          fill: isWhite ? palette.common.white : palette[colorPalette!][isNeutrals ? 600 : 500],
        },
        '& .bg': {
          fill: transparentBackground ? 'transparent' : backgroundFill,
        },
      },
      rtlFlip: {
        transform: 'scaleX(-1)',
      },
    };
  },
);

export type SVGProps = SVGComponentProps & {
  children?: never;
  rtlFlip?: boolean;
  colorPalette?: 'primary' | 'neutrals' | 'success' | 'job' | 'education' | 'hobby' | 'white';
  src: SVGComponent | ReactElement<SVGComponentProps>;
  transparentBackground?: boolean;
};

const SVGIllustration = ({
  src,
  colorPalette = 'primary',
  className,
  transparentBackground,
  rtlFlip,
  ...restProps
}: SVGProps) => {
  const {
    classes,
    cx,
    theme: { direction },
  } = useStyles({ colorPalette, transparentBackground });
  const shouldRtlFlip = direction === 'rtl' && rtlFlip;
  const classesNameValue = cx(classes.root, shouldRtlFlip && classes.rtlFlip, className);
  if (isValidElement<SVGComponentProps>(src)) {
    return cloneElement(src, {
      className: classesNameValue,
      ...restProps,
    });
  }
  const Component = src;
  return <Component className={classesNameValue} {...restProps} />;
};

export default SVGIllustration;
